import type { FaireProductEntity } from "../../entity_types/product";

export const p_67uhkkdyv8: FaireProductEntity = {
  token: "p_67uhkkdyv8",
  type: "product",
  name: "SKATE DECK BULLET Pool Shape",
  brandToken: "b_9grp69f3nm",
  brandName: "Hydroponic",
  imageUrl:
    "https://cdn.faire.com/fastly/c27434efd046c541a2a64b36f7de467328fa276190e3ce095bf6dbdf8c31b3a9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8d49fc8f435469a06ec637c61f205452a65db3f144c93fd7d64da15d98a1a73.jpeg",
    "https://cdn.faire.com/fastly/f97d48dc15a3f8eceb60e189e0ac4959ffb3f97bea62254be93c5320eef3de32.jpeg",
    "https://cdn.faire.com/fastly/533cc89c601a00a15f79d02a6e6d03346dcfd13831cbf0cead3fbec2f021b7a8.jpeg",
    "https://cdn.faire.com/fastly/455ff95c2478b3bb093d839fabd90457b96f9ff239e4c073a355585f777343e0.jpeg",
    "https://cdn.faire.com/fastly/ed69cc2695bf54679c85f92eb1ab66a75be613c0b41edb3c7c3bf7738ac69798.jpeg",
    "https://cdn.faire.com/fastly/3b21138e0a7834528c40a01ed2d811a39ea1c43cbec0cd63f956a98ac8c0fdef.jpeg",
    "https://cdn.faire.com/fastly/bbe24cbdb079da945a66535e264328c361e7e0c0b048d39a59f8c29777f1dd47.jpeg",
    "https://cdn.faire.com/fastly/e3ff41763b6e854615368c24b257a561e270d80774ea50d5333e624838856a1c.jpeg",
  ],
  priceDollars: 60.66,
  description:
    'Pool shape decks are bigger, sturdier skate decks that are shaped in the Style of 80\'s skateboarding, a time for pioneers that skated big vert ramps and pools. With the bloom of great concrete skateparks all over the world, these big decks are all you need to enjoy a throwback session with the older crew.\n\nDeck: 7-ply Hard Rock Canadian Maple + Epoxy Resin\n\nLength: 31.9" \n\nWidth: 8.75"\n\nWheel Base: 15"\n\nConcave: High',
  tags: [],
  msrpDollars: 121.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:14.985Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
